import { useContext } from "react";
import { UserContext } from "@/context/User/UserContext";
import { getSingleMasterInvoice } from "@/services/invoice-functions";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import InvoiceDetails from "@/components/InvoiceDetails";
import CollectFunds from "@/components/dialog/CollectFunds";
import InvoiceSkeleton from "@/components/skeleton/InvoiceSkeleton";
import { STALE_TIME_INVOICE } from "@/constants";

const CashOfficeCollection = () => {
	const { id } = useParams<{ id: string }>() as { id: string };
	const user = useContext(UserContext);

	const invoice = useQuery({
		queryKey: ["invoice", id],
		queryFn: () => getSingleMasterInvoice(user?.accessToken!, id),
		enabled: !!user?.accessToken,
		staleTime: STALE_TIME_INVOICE,
	});

	return (
		<div>
			{invoice.isLoading ? (
				<InvoiceSkeleton />
			) : invoice.isError ? (
				<div className="align-centre">
					<h5 className="text-center">Error loading claim.</h5>
				</div>
			) : (
				invoice.data && (
					<>
						<div className="flex gap-3 items-end justify-between">
							<h1 className="font-medium text-4xl">
								CLAIM NO: {invoice.data.invoicemasterid}
							</h1>
							{invoice.data.collected ? (
								<div className="bg-primary/20 text-primary px-4 py-2 rounded-md">
									Claim Processed
								</div>
							) : (
								<CollectFunds
									invoicemasterid={invoice.data.invoicemasterid}
									accessToken={user?.accessToken!}
									amountcollected={invoice.data.amount}
									phone={invoice.data.phone}
								/>
							)}
						</div>
						<InvoiceDetails invoice={invoice.data} accessToken={user?.accessToken!} />
					</>
				)
			)}
		</div>
	);
};

export default CashOfficeCollection;
